const ThirdPartyDataSources = {
  POCKET_RADAR: 'PocketRadar',
  TRACKMAN: 'Trackman'
};

export default ThirdPartyDataSources;